<template>
    <div class="cms-container mb-4">
        <ToastCMS ref="toast" />

        <!-- PREVIEW IMAGE -->
        <div v-if="showPreviewModal" class="preview-modal w-100 h-100 d-flex align-items-center justify-content-center"
            @click.self="closePreviewImage">
            <div class="d-block-align-items-center justify-content-center w-100 mx-3">
                <div class="modal-content bg-transparent position-relative border-0">
                    <button class="close-btn position-fixed text-white bg-transparent border-0"
                        @click="closePreviewImage">&times;</button>

                    <div class="d-flex justify-content-between align-items-center border-0">
                        <img :src="previewImages[currentPreviewIndex]" alt="Preview Image">
                    </div>
                </div>

                <div v-if="previewImages.length > 1" class="text-center mt-3">
                    <span class="text-white">Image {{ currentPreviewIndex + 1 }} of {{ previewImages.length }}</span>
                </div>
            </div>
        </div>

        <div class="sticky-controls">
            <div class="membership-wrapper d-flex align-items-center justify-content-between px-3"
                :class="{ 'drop-active': dragOver }" @dragover.prevent="dragOver = true" @dragleave="dragOver = false"
                @drop.prevent="handleDrop">
                <div class="member-affiliations-header text-dark">
                    Membership and Affiliations
                    <span v-if="dragOver" class="ml-2 text-primary" style="font-size: 14px;">(Drop to upload)</span>
                </div>
                <div class="d-flex gap-2">
                    <input type="file" ref="bulkInput" multiple accept="image/*" hidden @change="handleBulkUpload">
                    <button type="button" class="vmc-bg-prime-4 border-0 text-white rounded px-2 py-1"
                        @click="$refs.bulkInput.click()">
                        Add Image(s)
                    </button>
                </div>
            </div>
        </div>

        <form action="" id="membership" @submit.prevent="saveAllChanges">
            <div class="pb-3">
                <div class="grid-header">
                    <div class="w-100 mb-4" v-for="(container, index) in containers" :key="index">
                        <div class="d-flex px-3 align-items-center justify-content-between w-100 mt-2">
                            <div class="d-flex align-items-center justify-content-between w-100 mt-2">
                                <span class="logo-number text-dark">
                                    Logo Image # {{ index + 1 }}
                                </span>
                                <div class="d-flex align-items-center" style="gap:5px;">
                                    <button type="button" @click="previewImage(index)"
                                        class="vmc-bg-prime-4 text-white rounded px-3 py-1 border-0">
                                        View
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="mt-2 px-3">
                            <div class="img-placeholder-box" @click="triggerSingleUpload(index)">
                                <img v-if="container.image" :src="container.image" alt="Logo"
                                    style="height:100%; width:100%; object-fit:contain;">

                                <template v-else>
                                    <div class="w-100 h-100 d-flex flex-column justify-content-center align-items-center text-center"
                                        style="cursor:pointer;">
                                        <i class="material-symbols-outlined">upload</i>
                                        <span>Upload Photo</span>
                                    </div>
                                </template>
                                <input type="file" :ref="'file_' + index" accept="image/*" hidden
                                    @change="onImageChange($event, index)">
                            </div>

                            <button @click="removeContainer(index)" type="button"
                                class="vmc-bg-prime-6 w-100 text-white rounded px-2 py-1 border-0">
                                Remove
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </form>

        <div class="px-3 footer-action">
            <button type="submit" form="membership" class="vmc-bg-prime-4 border-0 text-white rounded px-3 py-1"
                :disabled="!hasChanges">
                Save All Changes
            </button>
        </div>
    </div>
</template>

<script>
import ToastCMS from '../ToastCMS.vue';

export default {
    name: "MembershipAffiliationsCMS",
    components: { ToastCMS },
    data() {
        return {
            containers: [],
            originalContainers: [],
            previewImages: [],
            showPreviewModal: false,
            currentPreviewIndex: 0,
            dragOver: false
        }
    },
    computed: {
        hasChanges() {
            return JSON.stringify(this.containers) !== JSON.stringify(this.originalContainers);
        }
    },
    methods: {
        triggerSingleUpload(index) {
            const input = this.$refs['file_' + index];
            if (input && input[0]) input[0].click();
        },

        handleBulkUpload(e) {
            const files = Array.from(e.target.files);
            this.processFiles(files);
            e.target.value = '';
        },

        handleDrop(e) {
            this.dragOver = false;
            const files = Array.from(e.dataTransfer.files);
            this.processFiles(files);
        },

        async processFiles(files) {
    const validImages = files.filter(f => f.type.startsWith("image/"));
    if (validImages.length === 0) return;

    for (const file of validImages) {
        const formData = new FormData();
        formData.append('image', file);

        try {
            const response = await fetch('/vmc/api/upload', {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('vmc_token')}`
                },
                body: formData
            });

            const data = await response.json();

            if (response.ok) {
                this.containers.push({ name: file.name, image: data.url });
            } else {
                console.error("Upload failed:", data.message);
            }
        } catch (error) {
            console.error("Upload error:", error);
        }
    }

    this.$refs.toast.showToast(`${validImages.length} logos added`, "success");
},

        async onImageChange(e, index) {
    const file = e.target.files[0];
    if (file && file.type.startsWith("image/")) {
        const formData = new FormData();
        formData.append('image', file);

        try {
            const response = await fetch('/vmc/api/upload', {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('vmc_token')}`
                },
                body: formData
            });

            const data = await response.json();

            if (response.ok) {
                this.$set(this.containers[index], 'image', data.url);
                this.$refs.toast.showToast(`Image updated`, "success");
            } else {
                console.error("Upload failed:", data.message);
            }
        } catch (error) {
            console.error("Upload error:", error);
        }
    }
},

        removeContainer(index) {
            this.containers.splice(index, 1);
            this.$refs.toast.showToast(`Logo Image ${index + 1} removed`, "error");
        },

        resetImage(index) {
            if (!this.containers[index].image) {
                this.$refs.toast.showToast(`No image attached`, "warning");
                return;
            }
            this.$set(this.containers[index], 'image', '');
            this.$refs.toast.showToast(`Image removed`, "error");
        },

        previewImage(index) {
            if (!this.containers[index].image) {
                this.$refs.toast.showToast("No images to view", "warning");
                return;
            }
            this.previewImages = [this.containers[index].image];
            this.currentPreviewIndex = 0;
            this.showPreviewModal = true;
        },

        closePreviewImage() {
            this.showPreviewModal = false;
            this.previewImages = [];
        },

        async loadFormData() {
            try {
                const token = localStorage.getItem('vmc_token');
                const response = await fetch(`${process.env.VUE_APP_API_URL}/api/content?_nocache=${new Date().getTime()}`, {
                    headers: { 'Authorization': `Bearer ${token}` }
                });
                const data = await response.json();
                if (data && Array.isArray(data.affiliates)) {
                    this.containers = data.affiliates.map(a => ({ name: a.name || '', image: a.image || '' }));
                    this.originalContainers = JSON.parse(JSON.stringify(this.containers));
                }
            } catch (error) {
                this.$refs.toast.showToast("Failed to load data", "error");
            }
        },

        async saveAllChanges() {
            try {
                const token = localStorage.getItem('vmc_token');
                const response = await fetch(`${process.env.VUE_APP_API_URL}/api/update`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    },
                    body: JSON.stringify({ affiliates: this.containers })
                });

                if (!response.ok) throw new Error();
                this.originalContainers = JSON.parse(JSON.stringify(this.containers));
                this.$refs.toast.showToast("Saved all changes.", "success");
                setTimeout(() => { window.location.reload(); }, 1500);
            } catch (error) {
                this.$refs.toast.showToast("Save failed.", "error");
            }
        }
    },
    async mounted() {
        await this.loadFormData();
    }
}
</script>

<style scoped>
.toast-container {
    position: fixed;
    top: 20px;
    right: 20px;
    width: 300px;
    z-index: 9999;
}

.sticky-controls {
    position: sticky;
    z-index: 10;
    background: white;
    top: 60px;
}

.drop-active {
    background-color: #f0f8ff !important;
    border: 2px dashed var(--vmc-primary-4) !important;
}

.img-placeholder-box {
    height: 200px;
    background-position: center;
    border: 1px solid gray;
    margin-bottom: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    cursor: pointer;
}

@media (min-width: 330px) {
    .membership-wrapper {
        padding: 15px 0;
        border-top: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
    }

    .member-affiliations-header {
        font-size: 20px;
        font-weight: 600;
    }

    .logo-number {
        font-size: 18px;
        font-weight: 600;
    }

    .grid-header>div {
        width: 100%;
    }

    .preview-modal {
        position: fixed;
        top: 0;
        left: 0;
        background: rgba(0, 0, 0, 0.8);
        z-index: 9999;
        overflow-y: hidden;
        overscroll-behavior: contain;
    }

    .modal-content img {
        max-width: 70vw;
        max-height: 70vh;
        width: auto;
        height: auto;
        object-fit: contain;
        display: block;
        margin: 0 auto;
    }

    .close-btn {
        top: 10px;
        right: 15px;
        font-size: 24px;
        cursor: pointer;
    }
}

@media (min-width: 992px) {
    .grid-header {
        display: flex;
        flex-wrap: wrap;
    }

    .grid-header>div {
        width: 50% !important;
        box-sizing: border-box;
    }
}

@media (min-width: 1200px) {
    .cms-container {
        margin-left: 310px;
        width: calc(100% - 310px);
        margin-top: 82px;
    }

    .sticky-controls {
        top: 82px;
    }
}

.footer-action {
    margin-top: 20px;
}
</style>